// extracted by mini-css-extract-plugin
module.exports = {"button":"viewGameLog_button__DuK6T"};